import { ReactComponent as ArrowLeft } from 'Assets/controls/arrow-left.svg';
import { useNavigate } from 'react-router-dom';
import styles from './PageNav.module.scss';

type PageNavProps = {
  content: string;
};

const PageNav: React.FC<PageNavProps> = ({ content }) => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  }

  return (
    <div className={styles.nav}>
      <button className={styles.nav__button} onClick={goBack}>
        <ArrowLeft
          className={styles.nav__button__icon}
          title="Go to the previous page"
        />
      </button>
      <h1 className={styles.nav__title}>{content}</h1>
    </div>
  );
};

export default PageNav;
